<app-card padding="5" [showHeader]="false" cardClass="border-dashed border-2 border-sky-500">
  <div class="border-dashed border-2 border-sky-500 p-10">
    <div class="row">
      <div class="col-12">
        <label class="f-w-600">Gestion de portapapeles</label>
      </div>
      <div class="col-12">
        <br/>
      </div>
      <div class="col-6 ">
        <div class="grid">
          <button
            mat-flat-button color="primary"
            class="mat-body f-w-500"
            (click)="onCopy()"
          >
            <i class="fi fi-br-copy-alt"></i>
            Copiar
          </button>
        </div>
      </div>
      <div class="col-6 ">
        <div class="grid">
          <button
            mat-flat-button color="primary"
            class="mat-body f-w-500"
            [disabled]="!haveClipboard"
            (click)="onPaste()"
          >
            <i class="fi fi-br-paste"></i>
            Pegar
          </button>
        </div>
      </div>
    </div>
  </div>
</app-card>

